import { Component } from "react"

class AccordionDetails extends Component {

  render() {

    return (
      <div {...this.props} >{this.props.children}</div>
    )
  }
}

export default AccordionDetails